/**
 * The shape an event takes, whatever it is about (ADR 0038). What it is about is its `ServiceType`,
 * so a yoga class and a yoga camp share a type and differ here. The value is the same in every
 * language.
 */
export enum EventFormat {
  CLASS = "class",
  WORKSHOP = "workshop",
  COURSE = "course",
  CAMP = "camp",
  COMPETITION = "competition",
  TALK = "talk",
}
